import React, { useState } from 'react';
import './footer.css';
function FooterBlock() {
  return (
    <footer>
      <div className='container'>
        <div className='row footer-block'>
          <div className='footer-txt col'>
            © 2022 Harbinger Group. All rights reserved.
          </div>
          <div className='col foolter-link'>
            <a className='link' href='https://harbingergroup.com/contact-us/' target="_blank">Help</a>
            <span className='small-separator'></span>
            <a className='link' href='mailto:venkatesh.c@harbingergroup.com' target="_blank">Contact Admin</a>
          </div>
        </div>

      </div>
    </footer>
  );
}
export default FooterBlock;